import i18n, { selectedLocale } from "@/i18n/i18n";
import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

const store = createStore({
    state: {
        user: {},
        collapsed: false,
        headerTitle: "Bosh sahifa",
        pageTitle: "",
        locale: selectedLocale,
    },
    mutations: {
        setUniversal: (state, action) => {
            const { key = "data", payload } = action;
            return (state[key] = payload);
        },

        authenticate(state, tokenResponse) {
            let { access_token, refresh_token } = tokenResponse;
            localStorage.setItem("accessToken", access_token);
            localStorage.setItem("refreshToken", refresh_token);
        },
        signOut(state) {
            state.user = {};
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            window.location.href = "/";
        },
        userData(state, userData) {
            state.user = userData;
        },
        updateLocale(state, newLocale) {
            state.locale = newLocale;
        },
        updateCollapsed(state, newCollapse) {
            state.collapsed = newCollapse;
        },
        updateHeaderTitle(state, title) {
            state.headerTitle = title;
        },
        updatePageTitle(state, name) {
            state.pageTitle = name;
        },
    },
    actions: {
        changeLocale(ctx, newLocale) {
            i18n.global.locale = newLocale;
            ctx.commit("updateLocale", newLocale);
        },
    },
    plugins: [
        createPersistedState({
            key: "console-davr-business",
            paths: [
                "collapsed",
                "headerTitle",
                "locale",
                "user",
            ],
        }),
    ],
});

export default store;
